var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8382 4.81798C13.0335 5.01323 13.0335 5.32982 12.8383 5.52509L7.182 11.182C7.08823 11.2757 6.96105 11.3284 6.82844 11.3284C6.69583 11.3284 6.56865 11.2758 6.47487 11.182L3.64645 8.35356C3.45118 8.1583 3.45118 7.84171 3.64645 7.64645C3.84171 7.45119 4.15829 7.45119 4.35355 7.64645L6.82841 10.1213L12.1311 4.81802C12.3264 4.62275 12.6429 4.62273 12.8382 4.81798Z",
    fill: "#000013"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecked);
export default __webpack_public_path__ + "static/media/IconChecked.793724960e1021f18437ce371aadbbcb.svg";
export { ForwardRef as ReactComponent };